import React from 'react';
import { createRoot } from 'react-dom/client';
import Layout from '@components/templates/Layout/Layout';

// Create a root.
const root = createRoot(document.getElementById('leadFormContainer'));

// Initial render
root.render(<Layout/>);
